var render = function (_h,_vm) {var _c=_vm._c;return _c('img',{attrs:{"src":(("/modules/openweb/js/vue/src/assets/icons/" + (_vm.props.name) + ".svg"))}})}
var staticRenderFns = []

export { render, staticRenderFns }